import { uploadImg } from '@/api/system/imageGroup'

// 检查是否自有域名
export const checkSelfDomain = (url) => {
  const selfDomainArr = ['ehafo.com', 'yihafo.com', 'yiqizuoti.com']
  return selfDomainArr.some((domain) => {
    return url.includes(domain)
  })
}

// 不上传至图片库
export const handleImgUpload = (blobInfo, success, failure) => {
  if (blobInfo.blob().size > 2097152) {
    failure('文件体积过大')
  }
  if ('image/jpeg, image/png,image/bmp,image/gif'.indexOf(blobInfo.blob().type) >= 0) {
    uploadPic(blobInfo.blob(), success, failure)
  } else {
    failure('图片格式错误')
  }
}
const uploadPic = (file, success, failure) => {
  const body = {
    file,
    add_to_lib: 0,
    upload: true,
  }
  uploadImg(body).then((res) => {
    if (res.code === 0) {
      success(res.data)
    } else {
      failure('上传失败')
    }
  })
}
